<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { useDeviceStore } from "@/entities/device/model";
import { useEvaluationStore } from "@/entities/evaluation/model";
import { useB2bPrice } from "@/features/b2b-price/model";
import { StepBackButton } from "@/features/step-back/ui";
import { UploadDevicesListForm } from "@/features/upload-devices-list/ui";
import { useGlobalStore } from "@/shared/model";
import { UiStepLayout } from "@/shared/ui";

const { t } = useI18n({ useScope: "global" });
const globalStore = useGlobalStore();
const deviceStore = useDeviceStore();
const evaluationStore = useEvaluationStore();
const { b2bPrice } = useB2bPrice();

/** Выбранное устройство для лида. Цепочка начинается с бренда и категории, дальше модель и конфигурация */
const device = computed(() => ({
    brand: deviceStore.brand?.name ?? "",
    model: deviceStore.chain.slice(2).join(" / "),
    grade: evaluationStore.answeredDevice?.grade ?? "",
    price: b2bPrice.value,
}));

function onListSent(): void {
    void globalStore.switchStep("thanksForOrder");
}
</script>

<template>
    <UiStepLayout>
        <template #header>
            <h2 class="title">{{ t("uploadDevicesList.title") }}</h2>
            <p class="subtitle">{{ t("uploadDevicesList.subtitle") }}</p>
        </template>

        <UploadDevicesListForm :device="device" @sent="onListSent">
            <template #back>
                <StepBackButton />
            </template>
        </UploadDevicesListForm>
    </UiStepLayout>
</template>

<style scoped>
.title {
    margin: 0;
    font-size: calc(var(--custom-font-size) * 1.429);
    font-weight: 700;
    line-height: 1.2;
}

.subtitle {
    margin: 8px 0 0;
    font-size: var(--custom-font-size);
    line-height: 1.429;
}
</style>
